import { useModuleBEM } from "@b2bportal/core-themes";
import { Button, ButtonTypeEnum } from "@tenant/ui";
import clsx from "clsx";
import styles from "./PromoBanner.module.scss";

export interface PromoBannerProps {
  title: string;
  description: string;
  ctaLabel?: string;
  onCtaClick?: () => void;
  imageUrl: string;
  imageAlt?: string;
  imagePosition?: "left" | "right";
  className?: string;
}

export const PromoBanner = ({
  title,
  description,
  ctaLabel,
  onCtaClick,
  imageUrl,
  imageAlt = "",
  imagePosition = "right",
  className,
}: PromoBannerProps) => {
  const [block, cn] = useModuleBEM(styles, "PromoBanner");

  return (
    <div
      className={clsx(
        block,
        { [cn("image-left")]: imagePosition === "left" },
        className
      )}
    >
      <div className={cn("copy")}>
        <p className={cn("title")}>{title}</p>
        <p className={cn("description")}>{description}</p>
        {onCtaClick && ctaLabel && (
          <Button
            className={cn("cta")}
            buttonType={ButtonTypeEnum.Secondary}
            onClick={onCtaClick}
          >
            {ctaLabel}
          </Button>
        )}
      </div>
      <div className={cn("media")}>
        <img src={imageUrl} alt={imageAlt} className={cn("image")} />
      </div>
    </div>
  );
};
